module.exports = __webpack_public_path__ + "static/media/12.4c00d4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/12.png
// module id = 1117
// module chunks = 0